var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculatorCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.5V3C7 2.44772 7.44772 2 8 2H9.25V7.5H7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 7.5V2H16C16.5523 2 17 2.44772 17 3V7.5H10.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71429 9C6.76751 9 6 9.83147 6 10.8571V20.1429C6 21.1685 6.76751 22 7.71429 22H16.2857C17.2325 22 18 21.1685 18 20.1429V10.8571C18 9.83147 17.2325 9 16.2857 9H7.71429ZM9 10.5H15C15.5523 10.5 16 10.9477 16 11.5V13.5C16 14.0523 15.5523 14.5 15 14.5H9C8.44772 14.5 8 14.0523 8 13.5V11.5C8 10.9477 8.44772 10.5 9 10.5ZM10 16.5C10 17.0523 9.55228 17.5 9 17.5C8.44772 17.5 8 17.0523 8 16.5C8 15.9477 8.44772 15.5 9 15.5C9.55228 15.5 10 15.9477 10 16.5ZM9 20.5C8.44772 20.5 8 20.0523 8 19.5C8 18.9477 8.44772 18.5 9 18.5C9.55228 18.5 10 18.9477 10 19.5C10 20.0523 9.55228 20.5 9 20.5ZM13 16.5C13 17.0523 12.5523 17.5 12 17.5C11.4477 17.5 11 17.0523 11 16.5C11 15.9477 11.4477 15.5 12 15.5C12.5523 15.5 13 15.9477 13 16.5ZM12 20.5C11.4477 20.5 11 20.0523 11 19.5C11 18.9477 11.4477 18.5 12 18.5C12.5523 18.5 13 18.9477 13 19.5C13 20.0523 12.5523 20.5 12 20.5ZM16 16.5C16 17.0523 15.5523 17.5 15 17.5C14.4477 17.5 14 17.0523 14 16.5C14 15.9477 14.4477 15.5 15 15.5C15.5523 15.5 16 15.9477 16 16.5ZM15 20.5C14.4477 20.5 14 20.0523 14 19.5C14 18.9477 14.4477 18.5 15 18.5C15.5523 18.5 16 18.9477 16 19.5C16 20.0523 15.5523 20.5 15 20.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorCard);
export default __webpack_public_path__ + "static/media/calculator-card.3bbce343f6f0a52c16073d661c0ce585.svg";
export { ForwardRef as ReactComponent };